import { ExamMode } from "app-layouts/ltr-layouts/Layout/components/Header/SimpleHeader";
import { TabsType } from "pages/assignment";
import { PAGE_SIZE } from "res/constants";
import { AssignmentActionTypes } from "./assignment.types";

const INITAIL_STATE = {
  assignmentData: [],
  offset: 1,
  isFetchingAssignments: true,
  errorFetchingAssignments: null,
  isLoadMore: false,
  ///GetAssignmentDetail By ID
  // assignmentDetailData: dataaa,
  assignmentDetailData: undefined,
  assignmentDetailResultData: undefined,
  isFetchingAssignmentDetail: true,
  errorFetchingAssignmentDetail: null,
  counter: undefined,
  ///GetAssignment Result By ID
  assignmentResultData: undefined,
  assignmentResultWarning: null,
  isFetchingAssignmentResult: true,
  errorFetchingAssignmentResult: null,
  ///GetAssignment Answer By ID
  assignmentAnswerData: undefined,
  isFetchingAssignmentAnswer: true,
  errorFetchingAssignmentAnswer: null,
  ///Post Assignment
  isFetchingPostAssignment: false,
  errorFetchingPostAssignment: null,
  //Get Results
  resultData: [],
  resultOffset: 1,
  isFetchingResults: true,
  errorFetchingResults: null,
  resultLoadMore: false,
  //Get Student Points
  studentPoints: [],
  isFetchingStudentPoints: true,
  errorFetchingStudentPoints: null,
  //Options
  showNextQuestion: false,
  //currentPage
  currentPage: TabsType.assignments,
  //assignmentMode
  assignmentMode: ExamMode.simple,
  //
  currentAssignmentID: 0
};

const AssignmentReducer = (state = INITAIL_STATE, action) => {
  switch (action.type) {

    case AssignmentActionTypes.RESET_PLAN_OFFSET:
      return {
        ...state,
        offset: 1,
        assignmentData: [],
        isLoadMore: false,
        isFetchingPostAssignment: false
      };

    case AssignmentActionTypes.RESET_RESULT_OFFSET:
      return {
        ...state,
        resultOffset: 1,
        resultData: [],
        resultLoadMore: false
      };

    case AssignmentActionTypes.FETCH_ASSIGNMENT_START:
      return {
        ...state,
        isFetchingAssignments: true,
        errorFetchingAssignments: null,
        counter: undefined
      };
    case AssignmentActionTypes.FETCH_ASSIGNMENT_SUCCESS:

      const assignmentList = state.offset !== 1 ? [...state.assignmentData, ...action.payload] : action.payload;
      const isLoadMore = action.payload.length >= PAGE_SIZE

      return {
        ...state,
        assignmentData: assignmentList,
        offset: isLoadMore ? state.offset + 1 : state.offset,
        isLoadMore: isLoadMore,
        isFetchingAssignments: false,
        counter: undefined

      }
    case AssignmentActionTypes.FETCH_ASSIGNMENT_FAILURE:
      return {
        ...state,
        isFetchingAssignments: false,
        errorFetchingAssignments: action.payload,
      };
    case AssignmentActionTypes.RESET_ASSIGNMENT_STATE:
      return {
        ...state,
        isFetchingAssignments: false,
        errorFetchingAssignments: action.payload,
      };
    //Get assignment Result By ID
    case AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_START:
      return {
        ...state,
        isFetchingAssignmentResult: true,
        errorFetchingAssignmentResult: null,
        assignmentResultWarning: null,
        //reset assignment props
        assignmentData: [],
        offset: 1,
        isLoadMore: false,
        //reset result props
        resultData: [],
        resultOffset: 1,
        resultLoadMore: false

      };
    case AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_SUCCESS:

      return {
        ...state,
        assignmentResultData: action.payload,
        isFetchingAssignmentResult: false
      }
    case AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_FAILURE:
      return {
        ...state,
        isFetchingAssignmentResult: false,
        errorFetchingAssignmentResult: action.payload,
      };
    case AssignmentActionTypes.FETCH_ASSIGNMENT_RESULT_WARNING:
      return {
        ...state,
        isFetchingAssignmentResult: false,
        assignmentResultData: undefined,
        assignmentResultWarning: action.payload,
      };
    //Get assignment Detail By ID
    case AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_START:
      return {
        ...state,
        isFetchingAssignmentDetail: true,
        errorFetchingAssignmentDetail: null,
        //reset assignment props
        assignmentData: [],
        offset: 1,
        isLoadMore: false,
        //reset result props
        resultData: [],
        resultOffset: 1,
        resultLoadMore: false,
        counter: undefined
      };
    case AssignmentActionTypes.SET_ASSIGNMENT_COUNTER:
      return {
        ...state,
        counter: action.payload,
      };
    case AssignmentActionTypes.SET_ASSIGNMENT_MODE:
      return {
        ...state,
        assignmentMode: action.payload,
      };
    case AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_SUCCESS:
      const { assignmentData, assignmentID } = action.payload;
      const counter = assignmentData.assignmentDuration * 60;
      const isRandomizeQuestion = assignmentData.isRandomizeQuestion;
      const isRandomizeAnswer = assignmentData.isRandomizeAnswer;
      let answerList = [];
      let questionList = [];
      let assignmentDetail = { ...assignmentData }
      if (isRandomizeQuestion) {
        questionList = action.payload.questionList.sort((a, b) => 0.5 - Math.random());
        assignmentDetail = { ...assignmentDetail, questionList }
      }
      if (isRandomizeAnswer) {
        questionList = action.payload.questionList;
        questionList.map(question => question.AssignmentQuestionAnswers.sort((a, b) => 0.5 - Math.random()))
        assignmentDetail = { ...assignmentDetail, questionList }
      }
      return {
        ...state,
        assignmentDetailData: state.currentAssignmentID === assignmentID && state.assignmentDetailData?.questionList ? { ...state.assignmentDetailData } : assignmentDetail,
        isFetchingAssignmentDetail: false,
        counter,
        currentAssignmentID: assignmentID,
        assignmentMode: ExamMode.simple
      }
    case AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_RESULT_SUCCESS:
      const { assignmentResultData } = action.payload;

      return {
        ...state,
        assignmentDetailResultData: assignmentResultData,
        isFetchingAssignmentDetail: false,
        assignmentMode: ExamMode.simple
      }
    case AssignmentActionTypes.FETCH_ASSIGNMENT_DETAIL_FAILURE:
      return {
        ...state,
        isFetchingAssignmentDetail: false,
        errorFetchingAssignmentDetail: action.payload,
      };
    //Get assignment Answer By ID
    case AssignmentActionTypes.FETCH_ASSIGNMENT_ANSWER_START:
      return {
        ...state,
        isFetchingAssignmentAnswer: true,
        errorFetchingAssignmentAnswer: null
      };
    case AssignmentActionTypes.FETCH_ASSIGNMENT_ANSWER_SUCCESS:

      return {
        ...state,
        // assignmentDetailData: action.payload,
        isFetchingAssignmentAnswer: false
      }
    case AssignmentActionTypes.FETCH_ASSIGNMENT_ANSWER_FAILURE:
      return {
        ...state,
        isFetchingAssignmentAnswer: false,
      };
    //Post assignment
    case AssignmentActionTypes.FETCH_POST_ASSIGNMENT_START:
      return {
        ...state,
        isFetchingPostAssignment: true,
      };
    case AssignmentActionTypes.FETCH_POST_ASSIGNMENT_SUCCESS:

      return {
        ...state,
        isFetchingPostAssignment: false,
        assignmentDetailData: undefined
      }
    case AssignmentActionTypes.FETCH_POST_ASSIGNMENT_FAILURE:
      return {
        ...state,
        isFetchingPostAssignment: false,
        errorFetchingPostAssignment: action.payload,
      };

    //Get Results
    case AssignmentActionTypes.FETCH_RESULTS_START:
      return {
        ...state,
        isFetchingResults: true,
        errorFetchingResults: null,
        counter: undefined
      };

    case AssignmentActionTypes.RESET_RESULTS_LOADMORE:
      return {
        ...state,
        resultLoadMore: true,
      };
    case AssignmentActionTypes.FETCH_RESULTS_SUCCESS:
      let resultList = [];
      if (state.resultOffset !== 1) {
        const newList = action.payload.filter(item => state.resultData.findIndex(obj => parseInt(obj.id) == parseInt(item.id)) === -1);
        resultList = [...state.resultData, ...newList]
      } else {
        resultList = action.payload
      }
      const offsetIsLoadMore = action.payload.length >= PAGE_SIZE;
      return {
        ...state,
        resultData: resultList,
        resultOffset: offsetIsLoadMore ? state.resultOffset + 1 : state.resultOffset,
        resultLoadMore: offsetIsLoadMore,
        isFetchingResults: false,
        counter: undefined

      }

    case AssignmentActionTypes.FETCH_RESULTS_FAILURE:
      return {
        ...state,
        isFetchingResults: false,
        errorFetchingResults: action.payload,
      };

    case AssignmentActionTypes.RESET_RESULTS_STATE:
      return {
        ...INITAIL_STATE,

      };
    case AssignmentActionTypes.SET_SHOW_NEXT_QUESTION:
      return {
        ...state,
        showNextQuestion: action.payload
      };

    //Get Student Points
    case AssignmentActionTypes.FETCH_STUNDENT_POINTS_START:
      return {
        ...state,
        isFetchingStudentPoints: true,
        errorFetchingStudentPoints: null,
      };
    case AssignmentActionTypes.FETCH_STUNDENT_POINTS_SUCCESS:
      return {
        ...state,
        studentPointsData: action.payload,
        isFetchingStudentPoints: false,
      }

    case AssignmentActionTypes.FETCH_STUNDENT_POINTS_FAILURE:
      return {
        ...state,
        isFetchingStudentPoints: false,
        errorFetchingStudentPoints: action.payload,
      };


    //set Answer
    case AssignmentActionTypes.SET_ANSWER:
      const { questionId, answerObject } = action.payload;
      const assignmentDetailData = state.assignmentDetailData;
      const questionIndex=assignmentDetailData.questionList.findIndex((item)=>item.id===questionId)

      assignmentDetailData.questionList[questionIndex].answered = (answerObject.answerIndex !== undefined && answerObject.answerIndex !== null) ? answerObject.answerIndex : answerObject.answerText || answerObject.attachmentList || answerObject.formula;
      if (answerObject.answerIndex !== undefined && answerObject.answerIndex !== null) {
        assignmentDetailData.questionList[questionIndex].AssignmentQuestionAnswers.map((ansewr, index) => {
          if (index === answerObject.answerIndex) {
            ansewr.isChoosed = true
          } else {
            ansewr.isChoosed = false
          }
        })
      } else {
        assignmentDetailData.questionList[questionIndex].answerText = answerObject.answerText;
        assignmentDetailData.questionList[questionIndex].formulaText = answerObject.formula;
        assignmentDetailData.questionList[questionIndex].attachmentList = answerObject.attachmentList;
      }

      const data = { ...state.assignmentDetailData, ...assignmentDetailData };
      return {
        ...state,
        assignmentDetailData: data
      };
    //reset error
    case AssignmentActionTypes.RESET_ERROR:

      return {
        ...state,
        errorFetchingPostAssignment: null
      };

    //set Current Page
    case AssignmentActionTypes.SET_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload
      };
    default:
      return state;
  }
};

export default AssignmentReducer;
